export class DataProtectionVariables {
    private static _POLICY_POPUP_MODES: Object = {
        "CREATE_VAPP": "createVapp",
        "UPDATE_VAPP": "updateVapp",
        "CREATE_VDC": "createVDC",
        "UPDATE_VDC": "updateVDC",
        "ADD_RESOURCE_POOL_POLICY": "addResourcePoolPolicy",
        "UPDATE_RESOURCE_POOL_POLICY": "updateResourcePoolPolicy",
        "ADD_VM_POLICY": "addVmPolicy",
        "UPDATE_VM_POLICY": "updateVmPolicy",
        "DELETE_RESOURCE_POOL_POLICY": "deleteResourcePoolPolicy",
        "DELETE_VM_POLICY": "deleteVmPolicy"
    };
    public static get POLICY_POPUP_MODES(): Object {
       return DataProtectionVariables._POLICY_POPUP_MODES;
    }

    private static _MODES: Object = {
        "VAPP": "vApp",
        "VDC": "VDC",
        "RESOURCE_POOL": "RESOURCE_POOL",
        "VM": "VM"
    };
    public static get MODES(): Object {
       return DataProtectionVariables._MODES;
    }

    private static _RESTORE_MODES: Object = {
        "VAPP": "vApp",
        "DELETED_VAPP": "deletedVapp",
        "VM": "vm",
        "DELETED_VM": "deletedVm"
    };
    public static get RESTORE_MODES(): Object {
       return DataProtectionVariables._RESTORE_MODES;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/dataprotection-variables.ts